import type { Candidate } from '@axiom/validation';

import type { ProfileHeaderDisplayName } from './profile-header-display-name-schema';

export const ProfileHeaderUtil = {
  getDisplayNameInitialValues(candidate: Candidate): ProfileHeaderDisplayName {
    return {
      displayFirstName: candidate.displayFirstName || candidate.firstName,
      displayLastName: candidate.displayLastName || candidate.lastName,
      pronouns: candidate.pronouns,
    };
  },
};
